<template>
  <div class="mb-15">
    <v-row no-gutters>
      <page-title :value="$t('features.nursery-web-school-setting-class')"></page-title>
      <v-spacer />
      <v-btn @click="openCreateDialog" color="primary" variant="flat">
        <v-icon start>mdi-plus</v-icon>
        {{ $t('settings.createClass') }}
      </v-btn>
    </v-row>

    <!-- 年度 -->
    <v-card variant="flat" class="mt-4 pa-2" color="grey-lighten-5">
      <v-container>
        <v-row align="center">
          <v-col cols="3" class="pl-0">
            <v-text-field
              v-model="yearFilterValue"
              :disabled="loading"
              type="number"
              hide-details="auto"
              variant="outlined"
              density="compact"
            >
              <template #append-inner>
                <span class="text-medium-emphasis text-no-wrap align-self-center">SY</span>
              </template>
            </v-text-field>
          </v-col>
          <v-col cols="9" align-self="center">
            <v-btn
              @click="listClass"
              :loading="loading"
              color="primary"
              variant="flat"
              class="search-button"
            >
              {{ $t('common.search') }}
            </v-btn>
          </v-col>
        </v-row>
      </v-container>
    </v-card>

    <!-- <v-data-table
      :headers="headers"
      :items="classList"
      :loading="loading"
      hide-default-footer="auto"
      class="mt-6"
      disable-sort
      disable-pagination
      :items-per-page="-1"
    >
    -->
    <v-data-table
      class="pt-6"
      :headers="headers"
      :items="classList"
      :items-per-page="-1"
      :loading="loading"
      color="primary"
    >
      <template v-slot:loading>
        <v-skeleton-loader type="table-tbody"></v-skeleton-loader>
      </template>

      <template v-slot:item.year="{ item }">
        <div class="d-flex align-center">
          {{ item.year }}
          <v-tooltip bottom>
            <template v-slot:activator="{ props }">
              <v-icon
                v-if="item.isActive"
                class="ml-1"
                x-small
                color="success"
                v-bind="props"
                >mdi-circle</v-icon
              >
            </template>
            <span>{{ $t('settings.currentYear') }}</span>
          </v-tooltip>
        </div>
      </template>

      <template v-slot:item.childrenAge="{ item }">
        {{ `${item.childrenAge} yrs` }}
      </template>

      <template v-slot:item.createdAt="{ item }">
        {{ formatDate(item.createdAt) }}
      </template>

      <template v-slot:item.edit="{ item }">
        <v-btn
          @click="clickClass(item)"
          :disabled="loading"
          color="primary"
          small
          variant="flat"
          block
        >
          {{ $t('common.edit') }}
        </v-btn>
      </template>

      <template v-slot:item.children="{ item }">
        <v-btn
          @click="searchChildren(item.classId)"
          :disabled="loading"
          color="primary"
          small
          variant="outlined"
          block
        >
          {{ $t('settings.childrenDetail') }}
        </v-btn>
      </template>

      <template v-slot:item.duplicate="{ item }">
        <v-btn
          @click="clickDuplicate(item)"
          :disabled="loading"
          color="secondary"
          variant="outlined"
          small
        >
          <v-icon start>mdi-file-multiple-outline</v-icon>
          {{ $t('settings.duplicate') }}
        </v-btn>
      </template>
      <template #bottom></template>
    </v-data-table>

    <!-- children dialog -->
    <v-dialog v-model="childrenDialog" width="700px">
      <v-card>
        <v-card-title>{{ $t('settings.childrenDetail') }}</v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12">
                <v-alert type="info" variant="outlined" color="primary" density="compact">
                  {{ $t('settings.useCheckboxes') }}
                </v-alert>
              </v-col>
            </v-row>
            <v-row no-gutters>
              <v-col cols="12">
                <v-data-table
                  v-model="childrenList"
                  :headers="childrenTableHeaders"
                  :items="allChildrenList"
                  item-value="childId"
                  :loading="loading"
                  show-select
                  density="compact"
                  hide-default-footer
                  :items-per-page="-1"
                  color="primary"
                >
                  <template v-slot:item.children="{ item }">
                    {{ `${item.lastName} ${item.firstName}` }}
                  </template>
                  <template v-slot:item.gender="{ item }">
                    <v-chip
                      v-if="item.gender == 'male'"
                      color="light-blue"
                      dark
                      small
                      >Male</v-chip
                    >

                    <v-chip v-else color="pink lighten-2" dark small
                      >Female</v-chip
                    >
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-container>
            <v-row>
              <v-btn @click="childrenDialog = false" color="grey" text
                >{{ $t('common.cancel') }}
              </v-btn>
              <v-spacer />
              <v-btn
                @click="updateClassChildren"
                :loading="loading"
                color="primary"
                variant="flat"
              >
                {{ $t('common.save') }}
              </v-btn>
            </v-row>
          </v-container>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- duplicate dialog -->
    <v-dialog v-model="duplicateDialog" width="700px">
      <v-form v-model="duplicateFormValid">
        <v-card>
          <v-card-title>{{ $t('settings.duplicateClass') }}</v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12">
                  <v-alert color="primary" variant="outlined" type="info" density="compact">
                    {{ $t('settings.childrenAutoAssigned') }}
                  </v-alert>
                </v-col>
              </v-row>
              <v-row align="center">
                <v-col cols="6"> {{ $t('settings.className') }} </v-col>
                <v-col cols="6">
                  <v-text-field
                    v-model="duplicateInput.to.className"
                    :rules="[required]"
                    variant="outlined"
                    clearable
                    hide-details
                    density="compact"
                  ></v-text-field>
                </v-col>
              </v-row>

              <v-row align="center">
                <v-col cols="6"> {{ $t('settings.targetYear') }} </v-col>
                <v-col cols="6">
                  <v-text-field
                    v-model="duplicateInput.to.year"
                    :rules="[required]"
                    type="number"
                    variant="outlined"
                    hide-details
                    density="compact"
                    :suffix="$t('setting.classDialog.year')"
                  ></v-text-field>
                </v-col>
              </v-row>

              <v-row align="center">
                <v-col cols="6"> {{ $t('settings.childrenAge') }} </v-col>
                <v-col cols="6">
                  <v-text-field
                    v-model="duplicateInput.to.childrenAge"
                    :rules="[required]"
                    type="number"
                    :suffix="$t('setting.classDialog.yearsOld')"
                    variant="outlined"
                    hide-details
                    density="compact"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-container>
              <v-row>
                <v-btn @click="duplicateDialog = false" color="grey" text>
                  {{ $t('common.cancel') }}
                </v-btn>
                <v-spacer />
                <v-btn
                  @click="duplicateClass"
                  :loading="loading"
                  :disabled="!duplicateFormValid"
                  color="primary"
                  variant="flat"
                >
                  {{ $t('settings.duplicate') }}
                </v-btn>
              </v-row>
            </v-container>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>

    <!-- create dialog -->
    <class-dialog-container
      dialogType="create"
      v-model:isOpen="createDialog"
    ></class-dialog-container>

    <!-- update dialog -->
    <class-dialog-container
      dialogType="update"
      v-model:isOpen="updateDialog"
    ></class-dialog-container>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import PageTitle from "@/components/atoms/PageTitle.vue";
import ClassDialogContainer from "@/containers/ClassDialogContainer.vue";
import { classEditModule } from "@/store/dataModules/classEditModule";
import { classModule } from "@/store/dataModules/classModule";
import LocalDataService from "@/service/LocalDataService";
import { NurseryClassResponse, NurseryChildResponse } from "chaild-api/lib";
import dayjs from "dayjs";
import ApiChildren from "../../api/ApiChildren";
import ApiClass from "@/api/ApiClass";
import ValidationMixin from "@/mixins/ValidationMixin";
import CommonUtil from "@/utils/CommonUtil";

export default defineComponent({
  name: "ClassSetting",

  mixins: [ValidationMixin],

  components: {
    PageTitle,
    ClassDialogContainer,
  },

  async mounted() {
    await this.listClass();
    await this.getAllChildren();
  },

  data() {
    return {
      loading: false,
      createDialog: false,
      updateDialog: false,
      childrenDialog: false,
      duplicateDialog: false,
      yearFilterValue: "",
      selectedClassId: 0,
      headers: [
        { title: this.$t('common.fiscalYear'), key: "year", sortable: false },
        { title: this.$t('settings.className'), key: "className", sortable: false },
        { title: this.$t('common.age'), key: "childrenAge", sortable: false },
        { title: this.$t('settings.createdDate'), key: "createdAt", sortable: false },
        { title: this.$t('settings.childrenDetail'), key: "children", sortable: false },
        { title: this.$t('common.edit'), key: "edit", sortable: false },
        { title: this.$t('settings.duplicate'), key: "duplicate", sortable: false },
      ],
      childrenList: [] as number[],
      allChildrenList: [] as NurseryChildResponse[],
      duplicateInput: {
        classId: "" as string | number,
        to: {
          className: "",
          childrenAge: 0,
          year: 2021 as number,
        },
      },
      duplicateFormValid: false,
      childrenTableHeaders: [
        { title: this.$t('settings.childrenDetail'), key: "children", sortable: false },
        { title: this.$t('common.gender'), key: "gender", sortable: false },
      ],
    };
  },

  watch: {
    createDialog: {
      handler(val: boolean) {
        if (!val) {
          this.clearValues();
          this.listClass();
        }
      },
    },
    updateDialog: {
      handler(val: boolean) {
        if (!val) {
          this.clearValues();
          this.listClass();
        }
      },
    },
  },

  computed: {
    classList: function (): NurseryClassResponse[] {
      return classModule.classes;
    },
  },

  methods: {
    async listClass() {
      this.loading = true;
      const nurseryId = LocalDataService.getNurseryId();
      if (nurseryId) {
        await classModule.listClass({
          nurseryId: nurseryId,
          year: this.yearFilterValue,
        });
      }
      this.loading = false;
    },
    async searchChildren(classId: number) {
      this.loading = true;
      const nurseryId = LocalDataService.getNurseryId();
      if (nurseryId) {
        this.selectedClassId = classId;
        const response = await ApiChildren.listChildren({
          nurseryId,
          classId,
        }).catch();
        if (response) {
          this.childrenList = response.map((c: NurseryChildResponse) => c.childId);
          this.childrenDialog = true;
        } else {
          this.childrenList = [];
        }
      }
      this.loading = false;
    },
    async getAllChildren() {
      this.loading = true;
      const nurseryId = LocalDataService.getNurseryId();
      if (nurseryId) {
        const response = await ApiChildren.listChildren({
          nurseryId,
        }).catch();
        if (response) {
          this.allChildrenList = response;
        } else {
          this.allChildrenList = [];
        }
      }
      this.loading = false;
    },
    async duplicateClass() {
      this.loading = true;
      const nurseryId = LocalDataService.getNurseryId();
      if (nurseryId) {
        const response = await ApiClass.duplicateClass({
          nurseryId,
          ...this.duplicateInput,
        }).catch(() => (this.loading = false));
        if (response) {
          alert(this.$t('settings.classDuplicatedSuccessfully'));
          this.duplicateDialog = false;
          await this.listClass();
        }
      }
      this.loading = false;
    },
    async updateClassChildren() {
      this.loading = true;
      const nurseryId = LocalDataService.getNurseryId();
      if (nurseryId) {
        const response = await ApiChildren.updateClassChildren({
          nurseryId,
          classId: this.selectedClassId,
          childrenIds: this.childrenList,
        }).catch(() => (this.loading = false));
        if (response) {
          this.childrenDialog = false;
          alert(this.$t('settings.savedSuccessfully'));
        }
      }
      this.loading = false;
    },
    clickClass(value: NurseryClassResponse) {
      if (value) {
        classEditModule.setClassId(value.classId as any);
        classEditModule.setClassName(value.className);
        classEditModule.setYear((value as any).year);
        classEditModule.setChildrenAge(String(value.childrenAge));
        this.updateDialog = true;
      }
    },
    clickDuplicate(value: NurseryClassResponse) {
      this.duplicateDialog = true;
      this.duplicateInput.classId = value.classId;
      this.duplicateInput.to.className = `${value.className} (Copy)`;
      this.duplicateInput.to.childrenAge = value.childrenAge;
      this.duplicateInput.to.year = value.year || 2021;
    },
    openCreateDialog() {
      classEditModule.setClassName("");
      classEditModule.setYear(parseInt(CommonUtil.getFiscalYear()));
      classEditModule.setChildrenAge("");
      this.createDialog = true;
    },
    clearValues() {
      classEditModule.setClassName("");
      classEditModule.setYear(parseInt(CommonUtil.getFiscalYear()));
      classEditModule.setChildrenAge("");
    },
    formatDate(value: string): string {
      if (!value) {
        return "";
      }
      return dayjs(value).format("DD/MM/YYYY");
    },
  },
});
</script>
